import sum from 'utils/sum';

export default function (data) {
  const size = data.size || data.length || 0;
  if (size === 0) return NaN;
  return sum(data) / size;
}
